import Portfolio from '../pages/Portfolio.js';
import Agence from '../pages/Agence.js';
import E404 from '../pages/E404.js';
import Legal from '../pages/Legal.js';

const Router
 = ({ page, clients }) => {
    return page === 'portfolio'
        ? <Portfolio clients={clients}/>
        : page === 'agence'
        ? <Agence/>
        : page === 'legal'
        ? <Legal/>
        : <E404 />
}

export default Router
;